import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const spouse: AnswerPathTreeNode = {
  path: 'spouse',
  children: [
    { path: 'exists', nodeId: NodeIds.insuredSpouseExists },
    { path: 'dateOfBirth', nodeId: NodeIds.insuredSpouseDateOfBirth },
  ],
};
